import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';
import { UntilDestroy } from '@ngneat/until-destroy';
import { AclPermissionDetail } from '@y42/acl/models';
import { createAclPermissionDetail } from '@y42/acl/util/create-acl-permission-detail';
import { connectState, InputObservable } from '@y42/angular/util';
import { BehaviorSubject, Observable } from 'rxjs';
import { toolbarBackdropClass } from '../../constants';

@UntilDestroy()
@Component({
  selector: 'y42-create-drawing-button',
  templateUrl: './create-drawing-button.component.html',
  styleUrls: ['./create-drawing-button.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CreateDrawingButtonComponent {
  @Input() active = false;

  @Input()
  @InputObservable()
  isCanvasEditable = createAclPermissionDetail({ allowed: false });
  private readonly isCanvasEditable$!: Observable<AclPermissionDetail>;

  @Output() readonly selectTool: EventEmitter<number> = new EventEmitter<number>();

  protected readonly drawingWidth$$ = new BehaviorSubject(drawingWidths.thin);

  protected readonly drawingWidths = drawingWidths;
  protected readonly toolbarBackdropClass = toolbarBackdropClass;

  readonly state = connectState(this, {
    isCanvasEditable: this.isCanvasEditable$,
  });

  onStartDrawing(width = this.drawingWidth$$.getValue()) {
    this.selectTool.emit(width);
    this.drawingWidth$$.next(width);
  }
}

const drawingWidths = {
  thin: 5,
  thick: 10,
};
